import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";
import { ToastContainer } from "react-toastify";
import { useLocation, matchPath } from "react-router-dom";

import { UserActionDialog } from "../../components/dialogs/UserActionDialog/UserActionDialog";
import { ROUTES_MAP } from "routes/constants";

import { VersionCount } from "./VersionCount/VersionCount";
import "react-toastify/dist/ReactToastify.css";
import "./App.scss";

export const App = ({ children }) => {
    const { pathname } = useLocation();

    const renderHelmet = useCallback(() => {
        const renderedRoute = Object.values(ROUTES_MAP).find((route) => matchPath(pathname, route));
        let title = "ScraperForce";

        if (renderedRoute && renderedRoute.title) {
            title = `${renderedRoute.title} - ${title}`;
        }

        return (
            <Helmet>
                <title>{title}</title>
            </Helmet>
        );
    }, [ pathname ]);

    return (
        <>
            { renderHelmet() }

            <div className={"page"}>
                {children}

                <UserActionDialog/>

                <VersionCount/>
            </div>

            <ToastContainer className="toast-container" />
        </>
    );
};

App.propTypes = { children: PropTypes.object.isRequired };
